import { render, staticRenderFns } from "./PreEdit.vue?vue&type=template&id=5a32eb5c&v-on-clickaway=cancel&"
import script from "./PreEdit.vue?vue&type=script&lang=ts&"
export * from "./PreEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports